/**
 * [判断是否是微信浏览器]
 * @returns
 */
const isWechatBrowsers = () => {
  let ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf("micromessenger") !== -1) {
    return true;
  } else {
    return false;
  }
};
// 获取url参数
const getQueryVariable = (variable: string) => {
  return (
    decodeURIComponent(
      // @ts-ignore url解码中文字符
      (new RegExp("[?|&]" + variable + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || ""
  );
};

/**
 * 判断是否为安卓浏览器
 */
const isAndroid = () => {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    return true;
  } else {
    return false;
  }
};

export default {
  isWechatBrowsers,
  getQueryVariable,
  isAndroid
};
